import { render, staticRenderFns } from "./OfferItemsTable.vue?vue&type=template&id=2c3a8ff2&scoped=true"
import script from "./OfferItemsTable.vue?vue&type=script&lang=ts"
export * from "./OfferItemsTable.vue?vue&type=script&lang=ts"
import style0 from "./OfferItemsTable.vue?vue&type=style&index=0&id=2c3a8ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a8ff2",
  null
  
)

export default component.exports